import { getQueryParam } from './get-query-param';

function isMobileSdk() {
  return getQueryParam('mode').toLowerCase() === 'mobile-sdk';
}

function getCheckoutStyle() {
  return {
    overlayBackgroundColor: getQueryParam('overlay-background-color'),
  };
}

export const mobileSDKUtils = {
  isMobileSdk,
  getCheckoutStyle,
};
